import { buildPager } from '@coveo/headless';
import { RsHTMLElement } from '../rs-htmlelement.js';
import styles from 'inline:./rs-pager.scss';

export class RsPager extends RsHTMLElement {
    pager;
    pagerState;

    styles() {
        return styles;
    }

    mounted() {
        this.pager = buildPager(this.bindings.engine, {
            options: {
                numberOfPages: this.numberOfPages
            }
        });

        this.pager.subscribe(() => {
            this.pagerState = this.pager.state;
            this.updatePager();
        });

        this.initEvents();
    }

    get firstButton() {
        return this.shadow.querySelector('.first');
    }

    get previousButton() {
        return this.shadow.querySelector('.previous');
    }

    get nextButton() {
        return this.shadow.querySelector('.next');
    }

    get lastButton() {
        return this.shadow.querySelector('.last');
    }

    get numberOfPages() {
        return parseInt(this.getAttribute('number-of-pages')) || 5;
    }

    get pages() {
        return this.shadow.querySelector('.pages');
    }

    get pageButtons() {
        return Array.from(this.shadow.querySelectorAll('.page'));
    }

    initEvents() {
        this.firstButton.addEventListener('click', () => this.pager.selectPage(1));
        this.lastButton.addEventListener('click', () => this.pager.selectPage(this.pagerState.maxPage));
        this.previousButton.addEventListener('click', () => this.pager.previousPage());
        this.nextButton.addEventListener('click', () => this.pager.nextPage());

        this.initPageButtonsEvents();
    }

    initPageButtonsEvents() {
        this.pageButtons.forEach((pageButton) => {
            pageButton.clickEventController = new AbortController();

            pageButton.addEventListener('click', (event) => {
                this.pager.selectPage(parseInt(event.target.textContent));
            }, { signal: pageButton.clickEventController.signal });
        });
    }

    removePageButtonsEvents() {
        this.pageButtons.forEach((pageButton) => {
            pageButton.clickEventController.abort();
        });
    }

    renderArrow() {
        return `
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.52689 3.75736L5.28425 8L9.52689 12.2426" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    renderExtremityArrow() {
        return `
            <svg viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="Line" d="M0.5 0.5L0.5 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Icon_2" d="M7.74221 9.48526L3.49957 5.24261L7.74221 0.999974" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    renderFirstButton() {
        return `<div class="extremity arrow first">${this.renderExtremityArrow()}</div>`;
    }

    renderPreviousButton() {
        return `<div class="arrow previous">${this.renderArrow()}</div>`;
    }

    renderNextButton() {
        return `<div class="arrow next">${this.renderArrow()}</div>`;
    }

    renderLastButton() {
        return `<div class="extremity arrow last">${this.renderExtremityArrow()}</div>`;
    }

    renderPage(page) {
        const classes = ['button', 'page'];

        if (this.pagerState.currentPage === page) {
            classes.push('current');
        }

        return `<div class="${classes.join(' ')}">${page}</div>`;
    }

    renderPages() {
        return `<div class="pages"></div>`;
    }

    updatePager() {
        this.firstButton.classList.toggle('disabled', this.pagerState.currentPage === 1);
        this.lastButton.classList.toggle('disabled', this.pagerState.currentPage === this.pagerState.maxPage);
        this.previousButton.classList.toggle('disabled', !this.pagerState.hasPreviousPage);
        this.nextButton.classList.toggle('disabled', !this.pagerState.hasNextPage);
        this.removePageButtonsEvents();
        this.pages.innerHTML = this.pagerState.currentPages.reduce((output, page) => output += this.renderPage(page), '');
        this.initPageButtonsEvents();
    }

    async render() {
        this.shadow.innerHTML = `
            <div class="pager">
                <div class="previous-next-wrapper">
                    ${this.renderFirstButton()}
                    ${this.renderPreviousButton()}
                </div>
                ${this.renderPages()}
                <div class="previous-next-wrapper">
                    ${this.renderNextButton()}
                    ${this.renderLastButton()}
                </div>
            </div>
        `;
    }
};